'use client';

import { Select, SelectProps } from 'antd';
import React, { useState } from 'react';

import Icon from '../icon/icon';
import styles from './dropdown.style';

/**
 * Props para el componente Dropdown.
 * Extiende todas las props del componente Select de Ant Design (`SelectProps`).
 */
interface DropdownProps extends SelectProps {
  /**
   * Estilos personalizados opcionales que se aplicarán al contenedor del dropdown.
   */
  style?: React.CSSProperties;
}

const defaultStyles: React.CSSProperties = {
  height: '42px',
  border: '1px solid rgba(217, 217, 217, 1)',
  borderRadius: '8px'
};

/**
 * Un componente Dropdown personalizado que envuelve el componente Select de Ant Design.
 * Proporciona un estilo coherente y un ícono de menú desplegable personalizado para la aplicación.
 * Acepta todas las props que acepta el componente `Select` de Ant Design.
 *
 * @param {DropdownProps} props - Las props para el componente Dropdown.
 *
 * @returns {JSX.Element} El componente Dropdown renderizado.
 */
const Dropdown = ({ allowClear = false, showSearch = false, style, ...props }: DropdownProps) => {
  const [rotate, setRotate] = useState(0);

  return (
    <Select
      size='large'
      showSearch={showSearch}
      allowClear={allowClear}
      style={{ ...defaultStyles, ...styles.select, ...style }}
      suffixIcon={
        <Icon
          className='bi-chevron-down'
          style={{ ...styles.selectIcon, transform: `rotate(${rotate}deg)` }}
        />
      }
      onOpenChange={(open: boolean) => setRotate(open ? 180 : 0)}
      {...props}
    />
  );
};

export default Dropdown;
